import { useState } from "react";
import "../../assets/scss/login-forms.scss";
import Header from "../../components/header/component";
import Footer from "../../components/footer/component";
import { useNavigate, useParams } from "react-router-dom";
import { resetPasswordAtempt } from "./actions";
import appLogger from "../../utils/app-logger";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSignInLink } from "../../utils/path-helper";
import { getSignUpLink, getDashboardLinkWithLocale } from "../../utils/path-helper";
import ReactLoader from "../../components/resumebuild-loader/component";
import { currentDomain } from "../../utils/general-config";
import { DomainEnum } from "../../services/enum/environment-enum";
import RBResetPassword from "./rb";
import LSResetPassword from "./ls";
import PSResetPassword from "./ps";
import SSResetPassword from "./ss";
import PSRResetPassword from "./PSReskining/psr";
import { readCookie } from "../../utils/helpers";
import { ROUTE_CONSTANT } from "../../routing/route-constants";
const ResetPassword = () => {
  const { t } = useTranslation();
  const { locale } = useParams();
  let signInLink = getSignInLink(locale, "");
  let signUpLink = getSignUpLink(locale, "");
  let dashboardLink = getDashboardLinkWithLocale(locale, "");

  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [searchParams] = useSearchParams();
  const [pwdErrorMsg, setPwdErrorMsg] = useState("");
  const [showLoader, setShowLoader] = useState("d-none");

  const onpasswordChange = (e) => {
    const {
      target: { value },
    } = e;
    setPassword(value);
  };
  const onconfirmPasswordChange = (e) => {
    const {
      target: { value },
    } = e;
    setConfirmPassword(value);
  };
  const token = searchParams.get("cd");
  //if (token != "" && token != null) {
  const userGuid = searchParams.get("uid");
  //const userGuid = "4ffffc0b949e4f1bb652aed0e9249404"; //TODO: get this from states;
  const saveClickHandler = (e) => {
    setShowLoader("d-block");
    if (validateData()) {
      var data = {
        userGuid: userGuid,
        newPassword: password,
        token: token,
      };

      resetPasswordAtempt(data)
        .then((response) => {
          const userguid = readCookie("userguid");
          if (userguid && currentDomain() === DomainEnum.SIGNSIMPLI) {
            window.location.assign(ROUTE_CONSTANT.USER_ADMIN_DASHBOARD); // user already logged in
          } else {
            navigate(signInLink); // user not logged in
          }
          const {
            data: {
              detail: { data },
            },
          } = response;
        })
        .catch((err) => {
          const { detail } = err;
          appLogger.log(detail); // TODO
          setShowLoader("d-none");
        });
    }
  };
  const navigateSignIn = () => {
    navigate(signInLink);
  };
  const navigateSignUp = () => {
    navigate(signUpLink);
  };
  const validateData = () => {
    let isValid = true;
    if (!password) {
      setPwdErrorMsg(t("generic_error.enter_password"));
      isValid = false;
      setShowLoader("d-none");
    }
    if (isValid && !confirmPassword) {
      setPwdErrorMsg(t("generic_error.confirm_password"));
      isValid = false;
      setShowLoader("d-none");
    }
    if (isValid && password !== "" && confirmPassword !== "") {
      if (password != confirmPassword) {
        setPwdErrorMsg(t("generic_error.unmatch_password"));
        isValid = false;
        setShowLoader("d-none");
      } else if (password === confirmPassword && password.length < 6 && confirmPassword.length < 6) {
        setPwdErrorMsg(t("generic_error.password_length"));
        isValid = false;
        setShowLoader("d-none");
      }
    }
    if (isValid) {
      setPwdErrorMsg("");
    }
    return isValid;
  };
  const domain = currentDomain().toLowerCase();

  return (
    <>
      <ReactLoader showloader={showLoader} />
      <Header />
      {(() => {
        switch (domain) {
          case DomainEnum.PDFSIMPLI:
            return (
              <PSRResetPassword
                onpasswordChange={onpasswordChange}
                password={password}
                onconfirmPasswordChange={onconfirmPasswordChange}
                confirmPassword={confirmPassword}
                pwdErrorMsg={pwdErrorMsg}
                saveClickHandler={saveClickHandler}
                navigateSignIn={navigateSignIn}
                signUpNavigate
              />
            );
          case DomainEnum.WORKSIMPLI:
            return (
              <PSRResetPassword
                onpasswordChange={onpasswordChange}
                password={password}
                onconfirmPasswordChange={onconfirmPasswordChange}
                confirmPassword={confirmPassword}
                pwdErrorMsg={pwdErrorMsg}
                saveClickHandler={saveClickHandler}
                navigateSignIn={navigateSignIn}
                signUpNavigate
              />
            );
          case DomainEnum.LEGALSIMPLI:
            return (
              <LSResetPassword
                onpasswordChange={onpasswordChange}
                password={password}
                onconfirmPasswordChange={onconfirmPasswordChange}
                confirmPassword={confirmPassword}
                pwdErrorMsg={pwdErrorMsg}
                saveClickHandler={saveClickHandler}
                navigateSignIn={navigateSignIn}
                signUpNavigate
              />
            );
          case DomainEnum.SIGNSIMPLI:
            return (
              <SSResetPassword
                onpasswordChange={onpasswordChange}
                password={password}
                onconfirmPasswordChange={onconfirmPasswordChange}
                confirmPassword={confirmPassword}
                pwdErrorMsg={pwdErrorMsg}
                saveClickHandler={saveClickHandler}
                navigateSignIn={navigateSignIn}
                signUpNavigate
              />
            );
          default:
          case DomainEnum.RESUMEBUILD:
            return (
              <RBResetPassword
                onpasswordChange={onpasswordChange}
                password={password}
                onconfirmPasswordChange={onconfirmPasswordChange}
                confirmPassword={confirmPassword}
                pwdErrorMsg={pwdErrorMsg}
                saveClickHandler={saveClickHandler}
                navigateSignIn={navigateSignIn}
                navigateSignUp={navigateSignUp}
              />
            );
        }
      })()}

      {domain === DomainEnum.PDFSIMPLI || domain === DomainEnum.WORKSIMPLI || domain === DomainEnum.SIGNSIMPLI ? (
        ""
      ) : (
        <Footer />
      )}
    </>
  );
};

export default ResetPassword;
